import React, { useState } from "react";
import PersonalDataDeletionForm from "./PersonalDataDeletionForm";
import Contact from "./Contact";
const DataDeletionInfo = () => {
  const [showForm, setShowForm] = useState(false);

  const handleOpenForm = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Delete Your Personal Data</h1>
      <p>
        At MastaKash, we value your privacy and respect your rights. If you wish to delete
        your personal data, you can easily request the deletion through the options below.
        Please note that while most personal data can be deleted, certain data may be
        protected by law or necessary for regulatory purposes, and cannot be removed.
      </p>

      <h2>What Data Can Be Deleted?</h2>
      <ul>
        <li><strong>Your Profile Information:</strong> Name, contact details, and profile pictures</li>
        <li><strong>Group Information:</strong> Data related to the groups you have created or joined</li>
        <li>
          <strong>Financial Data</strong>: Non-regulatory data such as saved preferences or non-transactional
          history
        </li>
      </ul>

      <h2>What Data Cannot Be Deleted?</h2>
      <ul>
        <li>
          <strong>Transaction Records</strong>: To comply with financial regulations, records of deposits,
          withdrawals, and loans must be retained for a specified period.
        </li>
        <li>
          <strong>Legal and Compliance Data</strong>: Any personal data necessary for legal obligations,
          audits, or disputes may not be deleted.
        </li>
      </ul>

      <h2>How to Request Data Deletion</h2>
      <ol>
        <li>
          <strong>Review the data to be deleted:</strong> Ensure you understand the
          implications of deleting your personal data, as it will be permanent.
        </li>
        <li>
          <strong>Submit Your Request:</strong> Click the "<strong>Request Data Deletion</strong>" button below to
          initiate your request.
        </li>
        <li>
          <strong>Confirmation:</strong> You will receive a confirmation email detailing
          the data that will be deleted, and we will process your request within 7 business
          days.
        </li>
      </ol>

      <p>
        <strong>Important:</strong> If you have any questions or concerns regarding what
        data will be deleted or retained, please contact our support team at{" "}
        <a href="mailto:support@mastakash.com">support@mastakash.com</a>.
      </p>

      <button
        onClick={handleOpenForm}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007BFF",
          color: "#FFF",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Request Data Deletion
      </button>

      {showForm && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#FFF",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              width: "90%",
              maxWidth: "500px",
            }}
          >
           <PersonalDataDeletionForm onClose={handleCloseForm} /> 
          </div>
        </div>
      )}

      <h2>Contact Us</h2>
      <p>
        If you have any concerns or need further clarification on the deletion process,
        please reach out to us:
      </p>

      <Contact/>
      
    </div>
  );
};

export default DataDeletionInfo;
